<template>
    <v-app-bar app>
        <div class="d-flex align-center">
            <!-- breeze logo -->
            <v-img
                    :src="require('@/assets/logo.png')"
                    alt="BreezeConnect Logo"
                    class="mx-2"
                    contain
                    max-height=32
                    max-width=180
            />

        </div>
        <v-toolbar-title>Pay My Bill</v-toolbar-title>
        <!-- spacer -->
        <v-spacer />

        <!-- breeze website link -->
        <ButtonWithTooltip
                tooltip="Return to Breeze Connect Website"
                icon="mdi-close"
                flat
                href="https://breezeconnect.com.au"
        />

    </v-app-bar>
</template>

<script>
    import ButtonWithTooltip from "./ButtonWithTooltip";
    export default {
        name: "AppBar",
        components: {ButtonWithTooltip}
    }
</script>